import React from 'react'

export const Home = () => {
  return (
    <div><h1 id='coming-soon'>Coming Soon</h1></div>
  )
}
